export interface IUsuarioRol {
  cvu?: string | null;
  usuario?: string | null;
  nombreCompleto?: string | null;
  rol?: string | null;
}

export class UsuarioRol implements IUsuarioRol {
  constructor(
    public cvu?: string | null,
    public usuario?: string | null,
    public nombreCompleto?: string | null,
    public rol?: string | null
  ) {}

  static fromObject(data: IUsuarioRol): IUsuarioRol {
    const usuario = new UsuarioRol();
    for (const [key, value] of Object.entries(data)) {
      usuario[key] = value;
    }
    return usuario;
  }
}
